import {
  REINDEXING_REQUEST,
  REINDEXING_ERROR,
  REINDEXING_SUCCESS,
  REINDEXING_RESET,
  CANCEL_DIGITAL_ORDER_ERROR,
  CANCEL_DIGITAL_ORDER_REQUEST,
  CANCEL_DIGITAL_ORDER_SUCCESS,
  CANCEL_DIGITAL_ORDER_RESET,
} from "./ActionType";

const idleOperation = () => ({
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
});

const hasRequestMeta = (meta) =>
  meta?.shopId !== null &&
  meta?.shopId !== undefined &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const beginOperation = (meta) => ({
  ...idleOperation(),
  isRequest: true,
  shopId: String(meta.shopId),
  requestId: meta.requestId,
});

const isActiveRequest = (operation, meta) =>
  hasRequestMeta(meta) &&
  operation.shopId === String(meta.shopId) &&
  operation.requestId === meta.requestId;

export const initialState = {
  reindex: idleOperation(),
  cancelDigitalOrder: idleOperation(),
};

const reindexReducer = (state = initialState, action) => {
  switch (action.type) {
    case REINDEXING_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        ...state,
        reindex: beginOperation(action.meta),
      };
    case REINDEXING_SUCCESS:
      if (!isActiveRequest(state.reindex, action.meta)) return state;
      return {
        ...state,
        reindex: {
          ...state.reindex,
          isRequest: false,
          isSuccess: true,
          isError: false,
          data: action.payload,
          error: null,
        },
      };
    case REINDEXING_ERROR:
      if (!isActiveRequest(state.reindex, action.meta)) return state;
      return {
        ...state,
        reindex: {
          ...state.reindex,
          isRequest: false,
          isSuccess: false,
          isError: true,
          data: null,
          error: action.payload,
        },
      };
    case REINDEXING_RESET:
      return { ...state, reindex: idleOperation() };
    case CANCEL_DIGITAL_ORDER_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        ...state,
        cancelDigitalOrder: beginOperation(action.meta),
      };
    case CANCEL_DIGITAL_ORDER_SUCCESS:
      if (!isActiveRequest(state.cancelDigitalOrder, action.meta)) return state;
      return {
        ...state,
        cancelDigitalOrder: {
          ...state.cancelDigitalOrder,
          isRequest: false,
          isSuccess: true,
          isError: false,
          data: action.payload,
          error: null,
        },
      };
    case CANCEL_DIGITAL_ORDER_ERROR:
      if (!isActiveRequest(state.cancelDigitalOrder, action.meta)) return state;
      return {
        ...state,
        cancelDigitalOrder: {
          ...state.cancelDigitalOrder,
          isRequest: false,
          isSuccess: false,
          isError: true,
          data: null,
          error: action.payload,
        },
      };
    case CANCEL_DIGITAL_ORDER_RESET:
      return { ...state, cancelDigitalOrder: idleOperation() };
    default:
      return state;
  }
};

export default reindexReducer;
